/**
 * @flow
 * */
import config from 'config';

import NetworkService from 'core/services/network/NetworkService';
import BaseSDK from 'core/sdk/BaseSDK';
import type { WithTotalCount } from 'types';

import type { ActivityLogFilterParams, ActivityLogModel } from './types';

class ActivityLogSDK extends BaseSDK {
    _rmtApiService: NetworkService;

    constructor() {
      super();
      this._rmtApiService = new NetworkService(config.rmtApi, []);
    }

    /**
     * getActivityLogs
     * @param {ActivityLogFilterParams} params - filter body, RMT 1-based Start / Count paging
     * @returns {Promise<WithTotalCount<ActivityLogModel>>} -
     */
    async getActivityLogs(params: ActivityLogFilterParams): Promise<WithTotalCount<ActivityLogModel>> {
      const { body } = await this._rmtApiService.makeAPIPostRequest(
        'ActivityLog/GetActivityLogs',
        { body: params, abortController: this.setAbortController('getActivityLogs') }
      );
      return body.Data;
    }

    /**
     * cancelActivityLogSDKCalls
     * @param {Object} params -
     * @returns {void} -
     */
    cancelActivityLogSDKCalls(params: { name: string | Array<string> }) {
      const { name } = params;
      this.abortCall(name);
    }
}

export default new ActivityLogSDK();
